export default "__VITE_ASSET__cbe5fec6__"